﻿"use strict";
export const ppUtils = (function () {
    const browser = {
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return pair[1]; }
            }
            return (false);
        }
    };

    function getUrl() {
        const urlStr = document.URL.split('//')[1].split('?')[0].split('#')[0];

        const url = urlStr.split('/').filter((item, key, arr) => {
            return (key != 0) ? true : false;
        });

        return url;
    }

    function reload() {
        $(document).on('click', 'a[data-action=reload]', function () {
            location.reload();
        });
    }

    return {
        browser,
        reload,
        getUrl
    }
})();